import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-comentario-dialog',
  templateUrl: './comentario-dialog.component.html',
  styleUrls: ['./comentario-dialog.component.scss']
})
export class ComentarioDialogComponent implements OnInit {

  idcita: number;
  comentarioTexto: string = '';
  guardando: boolean = false;
  usuario: string = '';

  tiposContacto: any[] = [];
  motivos: any[] = [];
  resultados: any[] = [];
  tipoContactoId: number = null;
  motivoId: number = null;
  resultadoId: number = null;
  opcionesLoaded: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ComentarioDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gateway: GatewayService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar
  ) {
    this.idcita = data.idcita;
  }

  ngOnInit() {
    const usuarioData = this.localSave.get('usuarioPGV');
    this.usuario = usuarioData ? (usuarioData.nombre || usuarioData.NOMBRE || '') : '';
    this.cargarOpciones();
  }

  cargarOpciones() {
    this.gateway.get('getcomentarioopciones', {}).then((res: any) => {
      this.tiposContacto = res.tipos || [];
      this.motivos = res.motivos || [];
      this.resultados = res.resultados || [];
      this.opcionesLoaded = true;
    }).catch(() => {
      this.opcionesLoaded = true;
    });
  }

  guardar(): void {
    if (!this.tipoContactoId || !this.motivoId || !this.resultadoId) {
      this.snackbar.open('Seleccione tipo de contacto, motivo y resultado', 'Cerrar', { duration: 3000 });
      return;
    }

    this.guardando = true;
    const usuarioData = this.localSave.get('usuarioPGV');
    this.gateway.get('guardarcomentariobitacora', {
      IDCITA: this.idcita,
      COMENTARIO: this.comentarioTexto ? this.comentarioTexto.trim() : '',
      USUARIO: this.usuario,
      TIPO_CONTACTO_ID: this.tipoContactoId,
      MOTIVO_ID: this.motivoId,
      RESULTADO_ID: this.resultadoId,
      IDUSUARIO: usuarioData ? (usuarioData.IDU || usuarioData.idagente || usuarioData.IDAGENTE) : null,
      IDROL: usuarioData ? (usuarioData.idrol || usuarioData.IDROL) : null,
      // Enviar nombre/correo ya resueltos desde localStorage (mismo patron que liberarcita).
      // Evita que el backend tenga que saber en que tabla vive cada rol.
      NOMBRE_USUARIO: this.localSave.get('userLoggedIn') || null,
      CORREO_USUARIO: this.localSave.get('email') || null
    }).then((res: any) => {
      this.guardando = false;
      this.snackbar.open('Comentario guardado exitosamente', 'Cerrar', { duration: 2000 });
      this.dialogRef.close(true);
    }).catch(err => {
      this.guardando = false;
      this.snackbar.open('Error al guardar el comentario', 'Cerrar', { duration: 3000 });
    });
  }

  cancelar(): void {
    this.dialogRef.close(false);
  }
}
